import { gql } from "@apollo/client";

export const GET_SECTION = gql`
    query GetSection($keyword: String, $isUse: Boolean) {
        getSection(keyword: $keyword, isUse: $isUse) {
            _id
            sectionKhName
            sectionEnName
            isUse
            remark
        }
    }
`;


export const UPDATE_SECTION_IS_USE = gql`
    mutation UpdateSectionIsUse($id: ID!, $isUse: Boolean) {
        updateSectionIsUse(_id: $id, isUse: $isUse) {
            status
            message {
                messageKh
                messageEn
            }
        }
    }
`

export const CREATE_SECTION = gql`
    mutation CreateSection($input: SectionInput) {
        createSection(input: $input) {
            message {
                messageKh
                messageEn
            }
            status
        }
    }
`


export const UPDATE_SECTION = gql`
    mutation UpdateSection($id: ID!, $input: SectionInput) {
        updateSection(_id: $id, input: $input) {
            message {
                messageKh
                messageEn
            }
            status
        }
    }
`;


export const DELETE_SECTION = gql`
    mutation DeleteSection($id: ID!) {
        deleteSection(_id: $id) {
            status
            message {
                messageEn
                messageKh
            }
        }
    }
`;